import { render, staticRenderFns } from "./PreRegistration.vue?vue&type=template&id=62c3c68a"
import script from "./PreRegistration.vue?vue&type=script&lang=js"
export * from "./PreRegistration.vue?vue&type=script&lang=js"
import style0 from "./PreRegistration.vue?vue&type=style&index=0&id=62c3c68a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports